import React from 'react';
import styled from 'styled-components';

import { Box, Flex, Image } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';
import { ServiceLinkWithName } from '@rover/react-lib/src/redux/ducks/serviceLinks.duck';
import { ServiceLandingEnum } from '@rover/types/src/ServiceLanding';

import ServiceLandingServices from './ServiceLandingServices';

type Props = {
  serviceLandingType: ServiceLandingEnum | null;
  serviceLinksWithDisplayName: ServiceLinkWithName[];
  imageSrc: string;
  children: React.ReactNode;
  columnGap?: string;
};

const StyledImage = styled(Image)`
  vertical-align: bottom;
`;

const ServiceLandingServicesWrapper: React.FC<Props> = ({
  serviceLandingType,
  serviceLinksWithDisplayName,
  imageSrc,
  children,
  columnGap = '32px', // 8x
}) => {
  return (
    <>
      {/* Mobile & Tablet: Image appears on top of the section */}
      {/* For consistent spacing, section top margins are applied to this element for mobile & tablet sizes */}
      <Flex
        display={['flex', 'flex', 'none']}
        justifyContent="center"
        width="100%"
        mt={['12x', '24x']}
      >
        <Box width="150px" maxWidth="50%" sx={{ aspectRatio: '1' }}>
          <StyledImage src={imageSrc} description="" width="100%" height="100%" />
        </Box>
      </Flex>

      <Section
        background="secondary"
        mt={['0x', '0x', '24x']} // on mobile & tablet, margins are applied to the image container above
        mb={['12x', '24x']}
        width="100%"
        position="relative"
        pt="6x"
        pb="6x"
      >
        {/* Heading spans over both image and links */}
        <ServiceLandingServices.Display textAlign={['left', 'left', 'center']}>
          {children}
        </ServiceLandingServices.Display>

        <Flex
          flexDirection="row"
          alignItems="flex-end"
          justifyContent="center"
          position="relative"
          gap="64px"
        >
          {/* Desktop: Image aligned to bottom edge of section */}
          <Box display={['none', 'none', 'block']} flex="0 0 200px">
            <StyledImage
              src={imageSrc}
              description=""
              width="100%"
              height="auto"
              marginBottom="-6x" // negates 6x of bottom-padding on Section
            />
          </Box>

          <Box flex="1 1 66%">
            <ServiceLandingServices
              serviceLandingType={serviceLandingType}
              serviceLinksWithDisplayName={serviceLinksWithDisplayName}
              columnGap={columnGap}
            />
          </Box>
        </Flex>
      </Section>
    </>
  );
};

export default ServiceLandingServicesWrapper;
